import { IS_APP, IS_TESTING } from "@/__main__/constants.mjs";
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import globals from "@/util/global-whitelist.mjs";
import isRouteOverlay from "@/util/is-route-overlay.mjs";

type DateParam = ConstructorParameters<DateConstructor>[0];

function getAge(birthDate: DateParam) {
  if (!birthDate) return 0;
  const bd = new Date(birthDate);
  const now = new Date();
  const diff = now.getTime() - bd.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
}

export function getAgeGroup(birthDate: DateParam): string | null {
  const age = getAge(birthDate);

  // following IAB Audience Taxonomy and Segmentation 1.1
  if (!age || age < 18) return null;
  if (age <= 20) return "18_20";
  if (age <= 24) return "21_24";
  if (age <= 29) return "25_29";
  if (age <= 34) return "30_34";
  if (age <= 39) return "35_39";
  if (age <= 44) return "40_44";
  if (age <= 49) return "45_49";
  if (age <= 54) return "50_54";
  if (age <= 59) return "55_59";
  if (age <= 64) return "60_64";
  if (age <= 69) return "65_69";
  if (age <= 74) return "70_74";
  if (age > 75) return "75+";

  return null;
}

// This is a safe version of the Page Visibility API that also
// handles all cases of browser, node, test environment, app, and overlays.
export async function isAppVisible() {
  return (
    // tests always visible
    IS_TESTING ||
    // overlays always visible
    isRouteOverlay() ||
    // browser mostly visible
    (!IS_APP && globals?.document?.visibilityState === "visible") ||
    // kustom metric
    Boolean(await blitzMessage(EVENTS.IS_APP_VISIBLE))
  );
}

export const getMemoryUsage = async () => {
  let ram = 0;
  if (IS_APP) {
    const heapStats = await globals.__BLITZ__?.process?.getHeapStatistics();
    ram = heapStats?.usedHeapSize * 1024;
    // @ts-ignore
  } else if (globals.performance.memory) {
    // @ts-ignore
    ram = globals.performance.memory.usedJSHeapSize;
  }
  return ram;
};
